const actions = {

    FILE_READ_FILE_REQUEST: 'FILE_READ_FILE_REQUEST',
    FILE_READ_FILE_SUCCESS: 'FILE_READ_FILE_SUCCESS',
    FILE_READ_FILE_ERROR: 'FILE_READ_FILE_ERROR',

    FILE_READ_ALL_REQUEST: 'FILE_READ_ALL_REQUEST',
    FILE_READ_ALL_SUCCESS: 'FILE_READ_ALL_SUCCESS',
    FILE_READ_ALL_ERROR: 'FILE_READ_ALL_ERROR',

    FILE_DELETE_FILES_REQUEST: 'FILE_DELETE_FILES_REQUEST',
    FILE_DELETE_FILES_SUCCESS: 'FILE_DELETE_FILES_SUCCESS',
    FILE_DELETE_FILES_ERROR: 'FILE_DELETE_FILES_ERROR',

    FILE_TOGGLE: 'FILE_TOGGLE',
    FILE_RESET: 'FILE_RESET',

    FILE_OPEN_FLOATING_VIEWER_REQUEST: "FILE_OPEN_FLOATING_VIEWER_REQUEST",
    FILE_OPEN_FLOATING_VIEWER_SUCCESS: "FILE_OPEN_FLOATING_VIEWER_SUCCESS",
    FILE_OPEN_FLOATING_VIEWER_ERROR: "FILE_OPEN_FLOATING_VIEWER_ERROR",
    FILE_CLOSE_FLOATING_VIEWER: "FILE_CLOSE_FLOATING_VIEWER",

    FILE_SET_FILE: "FILE_SET_FILE",
    FILE_SET_FILES: "FILE_SET_FILES",

    FILE_ROTATE_REQUEST: "FILE_ROTATE_REQUEST",
    FILE_ROTATE_SUCCESS: "FILE_ROTATE_SUCCESS",
    FILE_ROTATE_ERROR: "FILE_ROTATE_ERROR",

    readFile: fileId => ({
        type: actions.FILE_READ_FILE_REQUEST,
        fileId,
    }),
    readGlobalFiles: payload => ({
        type: actions.FILE_READ_ALL_REQUEST,
        payload,
    }),
    deleteGlobalFiles: request => ({
        type: actions.FILE_DELETE_FILES_REQUEST,
        request, // {ids: []}
    }),
    toggleFileManager: visible => ({
        type: actions.FILE_TOGGLE,
        visible,
    }),
    resetFileManager: () => ({
        type: actions.FILE_RESET,
    }),
    openFloatingViewer: file => ({
        type: actions.FILE_OPEN_FLOATING_VIEWER_REQUEST,
        file,
    }),
    closeFloatingViewer: () => ({
        type: actions.FILE_CLOSE_FLOATING_VIEWER,
    }),
    setGlobalFile: file => ({
        type: actions.FILE_SET_FILE,
        file,
    }),
    setGlobalFiles: files => ({
        type: actions.FILE_SET_FILES,
        files,
    }),
    rotateFile: (fileId, rotateDirection) => ({
        type: actions.FILE_ROTATE_REQUEST,
        fileId,
        rotateDirection,
    }),

};
export default actions;
